import NotificationsIcon from "@mui/icons-material/Notifications";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

const NoNotificationsAvailable = () => {
  const theme = useTheme();
  const { t } = useTranslation(["common"]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        width: "100%",
      }}
      data-testid="no-notification-available"
    >
      <Box sx={{ textAlign: "center" }}>
        <NotificationsIcon
          sx={{
            transform: "rotateZ(-24deg)",
            color: theme.tokens.FuelColorTextDisabled,
            paddingBottom: theme.tokens.FuelSpacing2,
            textAlign: "center",
            fontSize: "2.5rem",
          }}
          data-testid="no-notification-available-icon"
        />
        <Typography
          component="h6"
          sx={{
            fontWeight: 600,
            fontSize: "14px",
            paddingBottom: theme.tokens.FuelSpacing1,
          }}
        >
          {t("header.notificationMenu.noNotifications.title")}
        </Typography>
        <Typography sx={{ fontWeight: 400, fontSize: "12px" }}>
          {t("header.notificationMenu.noNotifications.subTitle")}
        </Typography>
      </Box>
    </Box>
  );
};

export default NoNotificationsAvailable;
